import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useChat } from "./ChatProvider";

/** Legacy route — opens floating chat and redirects home. */
export function ChatPage() {
  const { canView, setIsOpen } = useChat();

  useEffect(() => {
    if (canView) setIsOpen(true);
  }, [canView, setIsOpen]);

  return <Navigate to="/" replace />;
}
